import { render, staticRenderFns } from "./ObsequiosFacturador.vue?vue&type=template&id=4a614d1c&scoped=true"
import script from "./ObsequiosFacturador.vue?vue&type=script&lang=js"
export * from "./ObsequiosFacturador.vue?vue&type=script&lang=js"
import style0 from "./ObsequiosFacturador.vue?vue&type=style&index=0&id=4a614d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a614d1c",
  null
  
)

export default component.exports